<div id="sizer">
  <div #root id="root">
  </div>
</div>
<div id="overlay"></div>